<template>
    <div>
        <div class="flex flex-col space-y-2">
            <div
                v-for="transaction in transactions"
                class="border border-black/5 dark:border-white/10 flex flex w-full w-full min-w-0 items-center overflow-hidden rounded-xl bg-indigo-100 bg-indigo-100 bg-white p-4 text-white text-white shadow-xs dark:bg-white/[0.02]"
            >
                {{ transaction.created_at }}
                

                <router-link
                    :to="{
                        name: 'user.order',
                        params: { order_id: transaction.order_id },
                    }"
                    target="_blank"
                    class="text-indigo-400 hover:cursor-pointer hover:text-indigo-700 hover:underline"
                >
                    #{{ transaction.id }}
                </router-link>
                <status class="ml-auto" :status="transaction.status" />
                <template v-if="transaction.card">
                    <card-brand-icon :brand="transaction.card.brand" />
                    {{ transaction.card.first_6 }}*{{ transaction.card.last_4 }}
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import SubmitButton from "../forms/SubmitButton.vue";
import Card from "../layouts/Card.vue";
import Status from "../layouts/Status.vue";
import CardBrandIcon from "../layouts/CardBrandIcon.vue";
export default {
    components: { CardBrandIcon, Status, Card, SubmitButton },
    props: ["audit"],
    data() {
        return {
            loading: false,
            transactions: [],
        };
    },

    mounted() {
        this.store();
    },

    methods: {
        store() {
            this.loading = true;

            axios
                .post("/api/audit/" + this.audit.id + "/refund-all")
                .then(({ data }) => {
                    this.transactions = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
